import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import useLoyaltyUserBenefitView from 'loyalty/hooks/useLoyaltyUserBenefitView'
import { useAppSelector } from 'hooks/reduxHooks'
import { useIntl } from 'react-intl'
import getLoyaltyDisplayTier from 'loyalty/selectors/getLoyaltyDisplayTier'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'
import LoyaltyEsimBenefitsInfoContent from './LoyaltyEsimBenefitsInfoContent'

function LoyaltyEsimBenefitsInfoModal() {
  const intl = useIntl()
  const tier = useAppSelector(getLoyaltyDisplayTier)
  const tierDisplayName = tier ? getLoyaltyTierDisplayName(tier) : ''
  const benefit = useLoyaltyUserBenefitView('esim_package')
  const gbValue = benefit?.benefit?.value?.amount

  if (!gbValue) return null

  return (
    <ModalBase size="S">
      <ModalHeader title={intl.formatMessage({
        id: 'DZqzzCIpGgWjlfqKmZD_',
        defaultMessage: '{gbValue}GB Free Data Roaming for Société {tierName} members',
        description: 'Title for the generic eSIM benefit info modal showing data amount and tier',
      }, { gbValue, tierName: tierDisplayName })}
      />
      <ModalBody>
        <LoyaltyEsimBenefitsInfoContent />
      </ModalBody>
    </ModalBase>
  )
}

export default LoyaltyEsimBenefitsInfoModal
